import { FlashNoticeVariant } from 'components/FlashNotice'
import { showFlashNotice } from 'components/FlashNotice/duck/actions'

import { User } from '../../../../../../../../entities-next/user'

export function successfulUserUpdateAction(corporate: Pick<User, 'email'>) {
  return showFlashNotice({
    message: `User "${corporate.email}" successfully updated!`,
    autoHide: true,
    variant: FlashNoticeVariant.success,
  })
}

export function successfulUserCreationAction(corporate: Pick<User, 'email'>) {
  return showFlashNotice({
    message: `User "${corporate.email}" successfully created!`,
    autoHide: true,
    variant: FlashNoticeVariant.success,
  })
}

export function failedUserOperationAction(e: Error) {
  return showFlashNotice({
    message: e.message,
    autoHide: false,
    variant: FlashNoticeVariant.error,
  })
}
